// import http from "./httpService";
// const apiUrl = process.env.REACT_APP_API_URL;
// const apiEndpoint = apiUrl + "/attachments";

// export const saveAttachments = (formData, id) => {
//   http.put(apiEndpoint + "/" + id, formData);
// };

// export const deleteAttachments = async (filePath, id, type) => {
//   await http.delete(apiEndpoint + "/" + id + "/" + type + "/" + filePath);
// };
import http from "./httpService";
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl + "/attachments";

export const saveAttachments = async (files, type, id, onUploadProgress) => {
  const formData = new FormData();
  formData.append("type", type);
  for (let x = 0; x < files.length; x++) {
    formData.append("attachments", files[x]);
  }

  // Add custom headers
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  return await http.put(
    `${apiEndpoint}/${id}`, 
    formData, 
    {
      headers,
      onUploadProgress: (progressEvent) =>
        onUploadProgress(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        ),
    }
  );
};

export const deleteAttachments = async (filePath, id, type) => {
  await http.delete(apiEndpoint + "/" + id + "/" + type + "/" + filePath);
};

export const uploadAttachment = (files,config) => {

  if(config){
    return http.post(apiEndpoint, files,config);
  }
  return http.post(apiEndpoint, files);


};